import React from 'react';
import Layout from '@/Shared/Layout';
import {InertiaLink, useForm, usePage} from "@inertiajs/inertia-react";
import LoadingButton from "@/Shared/LoadingButton";
import TextInput from "@/Shared/TextInput";
import TextArea from "@/Shared/TextArea";
import {Inertia} from "@inertiajs/inertia";
import DeleteButton from "@/Shared/DeleteButton";
import MetaInfoForm from "@/Pages/MetaInfo/Assets/MetaInfoForm";

const Edit = () => {
  const {static_page} = usePage().props;

  const {data, setData, errors, post, processing} = useForm({
    title: static_page.title || '',
    description: static_page.description || '',
    keywords: static_page.keywords || '',
    url: static_page.url || '',
    def_image_logo: '',
  });

  function handleSubmit(e) {
    e.preventDefault();
    post(route('static-page.update', static_page.static_page_id).url());
  }

  function destroy() {
    if (confirm('Are you sure you want to delete this meta info?')) {
      Inertia.delete(route('static-page.destroy', static_page.static_page_id));
    }
  }

  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('static-page')}
          className="text-indigo-600 hover:text-indigo-700"
        >
          Static Pages
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Edit
      </h1>
      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form onSubmit={handleSubmit}>
          <MetaInfoForm  errors={errors} data={data} setData={setData}/>
          <div className="flex items-center justify-between px-8 py-4 bg-gray-100 border-t border-gray-200">
            <DeleteButton onDelete={destroy}>Delete Meta Info</DeleteButton>
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Edit Static Page
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

Edit.layout = page => <Layout title="Edit static page" children={page}/>;
export default Edit;
